// @ts-ignore
import { AdSlot as AdSlotBase } from "react-dfp";

import { TopicElement as TopicElementType } from "shared/types";
import { Topic } from "shared/types";
import * as Items from "features/media/components/atoms/TopicElement";
import { AdUnitProps } from "features/media/utils/AdUnitProps";
import tw from "twin.macro";

const AdContainer = tw.div`flex-center mb-8`;

const AdSlot = tw(AdSlotBase)`w-[90vw] flex-center`;

interface Props {
  data: TopicElementType;
  index: number;
  topic: Topic;
}

export const TopicElement = (props: Props) => {
  const { data, index, topic } = props;

  const item = (() => {
    switch (data.formatType) {
      case "small_header":
        return <Items.SmallHeader {...props} />;
      case "medium_header":
        return <Items.MediumHeader {...props} />;
      case "large_header":
        return <Items.LargeHeader {...props} />;
      case "table_of_contents":
        return <Items.TableOfContents {...props} />;
      case "medium_image":
      case "large_image":
        return <Items.TopicImage {...props} />;
      case "quote":
        return <Items.Quote {...props} />;
      case "fortune":
        return <Items.Fortune {...props} />;
      case "fortune_with_stories":
        return <Items.Fortune {...props} withStories />;
      case "simple_fortune":
        return <Items.FreeFortuneBotLink {...props} />;
      case "link":
        return <Items.Link {...props} />;
      case "link_button":
        return <Items.LinkButton {...props} />;
      case "link_button_2":
        return <Items.LinkButton2 topicElement={props.data} />;
      case "text":
        return <Items.Text {...props} />;
      case "text_2":
        return <Items.TextOfFortuneTeller topicElement={props.data} />;
      case "divine_tarot":
        return <Items.DevineTarot {...props} />;
      case "divine_birthday":
        return <Items.DevineBirthday {...props} />;
      case "devine_match":
        return <Items.DevineMatch {...props} />;
      case "quiz":
        return <Items.Quiz {...props} />;
      case "topic_item":
        return <Items.Topic {...props} />;
      case "movie":
        return <Items.Movie {...props} />;
      default:
        return <>{props.data.formatType}</>;
    }
  })();

  const ad = (() => {
    switch (index) {
      case 2: {
        return !topic?.isContributeToConversionToMiror ? (
          <AdContainer>
            <AdSlot {...AdUnitProps.forAds.pageTop(topic)} />
          </AdContainer>
        ) : null;
      }
      case 10: {
        return !topic?.isContributeToConversionToMiror ? (
          <AdContainer>
            <AdSlot {...AdUnitProps.forAds.pageMiddle(topic)} />
          </AdContainer>
        ) : null;
      }
      case 20: {
        return (
          <AdContainer>
            <AdSlot {...AdUnitProps.adTypes[topic.adType!].pageMiddle(topic)} />
          </AdContainer>
        );
      }
      default:
        null;
    }
  })();

  return (
    <div
      tw="flex flex-col justify-center mb-8 relative"
      css={{ maxWidth: "inherit" }}
    >
      {ad}
      {item}
    </div>
  );
};
